import OutputFormSection from './OutputFormSectionContainer'

export default OutputFormSection
